import React, { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Button from '@ingka/button';
import { useTranslation } from 'react-i18next';
import styles from './LogoutButton.module.scss';

/* eslint-disable-next-line */
export interface LogoutButtonProps {}

export const LogoutButton: React.FC = () => {
  const { logout, isLoading } = useAuth0();
  const { t } = useTranslation();

  const logoutCb = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.preventDefault();
      logout({ logoutParams: { returnTo: window.location.origin } });
    },
    [logout]
  );
  return (
    <Button
      className={styles['user-button']}
      type="tertiary"
      text={`${t('header-log-out-btn')}`}
      disabled={isLoading}
      onClick={logoutCb}
    />
  );
};
